/**
 * Project: papyrus-ui
 * FilePath: /src/client/fuse-configs/fuseSettingsConfig.js
 * File: fuseSettingsConfig.js
 * Created Date: Thursday, March 14th 2019, 9:59:45 am
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Mon Apr 01 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

const common = {
  layout: {
    style: 'layout1',
    config: {
      scroll: 'content',
      navbar: {
        display: true,
        folded: true,
        position: 'left'
      },
      toolbar: {
        display: true,
        style: 'fixed',
        position: 'below'
      },
      footer: {
        display: false,
        style: 'fixed',
        position: 'below'
      },
      leftSidePanel: {
        display: true
      },
      rightSidePanel: {
        display: true
      },
      mode: 'fullwidth'
    }
  },
  customScrollbars: true
}

const codingConfig = {
  ...common,
  logo: 'assets/images/logos/anexsys-a-green-small.png',
  name: 'Objective Coding',
  theme: {
    main: 'default',
    navbar: 'mainThemeDark',
    toolbar: 'mainThemeLight',
    footer: 'mainThemeDark'
  }
}

const anexsysConfig = {
  ...common,
  logo: 'assets/images/logos/anexsys-a-green-small.png',
  name: 'Anexsys',
  theme: {
    main: 'anexsys',
    navbar: 'anexsys',
    toolbar: 'anexsys',
    footer: 'mainThemeDark',
    colours: require('./brandColours/anexsys.colours.json')
  }
}

const hobsConfig = {
  ...common,
  logo: 'assets/images/logos/hobs-medium-whiteBg.png',
  name: 'Hobshare',
  theme: {
    main: 'hobshare',
    navbar: 'hobshare',
    toolbar: 'hobshare',
    footer: 'mainThemeDark',
    colours: require('./brandColours/hobs.colours.json')
  }
}

const DEFAULT_BRAND = 'anexsys'
const BRAND_CONFIGS = {
  anexsys: anexsysConfig,
  hobshare: hobsConfig,
  coding: codingConfig
}
export default (() => {
  return BRAND_CONFIGS[process.env.REACT_APP_FLAVOUR] || BRAND_CONFIGS[DEFAULT_BRAND]
})()
